const HeaderModal = ({ titulo, dissmiss, danger }) => {
  return (
    <>
      <div className={`modalHeader ${danger ? "bgcG-danger" : "bgcG-latex30"}`}>
        <h1 className="modalTitle rb18b c-white">
          {titulo === "" ? "Error en el sistema" : titulo}
        </h1>
        <div className="cruz" onClick={dissmiss}>
          <div className="cruzParte1"></div>
          <div className="cruzParte2"></div>
        </div>
      </div>
    </>
  );
};

export default HeaderModal;
